import React from 'react';
// import LandingFormHeader from '@components/Landing/LandingFormHeader/LandingFormHeader';

const IsTemporaryUserForm = () => {
  return (
    <div className='font-bold'>
      You have either not set your password or not confirmed your email. Please check your email (and junk) for a link!
    </div>
  );
};

export default IsTemporaryUserForm;
